module.exports = __webpack_public_path__ + "img/plus_price_icon2_mobile.a83a19f5.png";